module.exports = __webpack_public_path__ + "static/media/ThingsToBring_green.83bc3a06.png";